export default __webpack_public_path__ + "static/media/MTH-logo.feef4a04.svg";